import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TicketToolTab } from 'src/app/models/enums';
import { IAffiliate } from '../../models/user/affiliate.interface';
import { IUserTM } from '../../models/user/userTM.interface';
import { AffiliateRole } from '../../models/util/tmEnums';
import { AuthenticationService } from '../../services/authentication.service';
import { TicketManagerUserService } from '../../services/ticketManagerUser.service';

@Component({
  selector: 'app-ticket-tools',
  templateUrl: './ticket-tools.component.html',
  styleUrls: ['./ticket-tools.component.less']
})
export class TicketToolsComponent implements OnInit, OnDestroy {



  selectedTab: TicketToolTab = TicketToolTab.CashierSearch;
  ticketToolTabEnum = TicketToolTab;
  tmUser: IUserTM;
  affiliate: IAffiliate;
  affiliateRoleEnum = AffiliateRole;
  protected subscription: Subscription = new Subscription();

  constructor(private ticketManagerUserService: TicketManagerUserService, private authentificationService: AuthenticationService) { }

  ngOnInit(): void {
    this.subscription.add(this.ticketManagerUserService.tmUserChangedSource$.subscribe(() => this.tmUser = this.ticketManagerUserService.user));
    this.subscription.add(this.authentificationService.loggedAffiliateChangedSource$.subscribe(() => this.affiliate = this.authentificationService.loggedAffiliate));
    this.tmUser = this.ticketManagerUserService.user;
    this.affiliate = this.authentificationService.loggedAffiliate;
  }

  changeTab(tab: TicketToolTab): void {
    this.selectedTab = tab;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
